<template>
  <div>
    <div class="mb-3">
      <label class="d-block mb-2">Chọn phân loại</label>
      <el-radio-group v-model="form.category" size="small">
        <el-radio label="special">Gia sư đặc biệt</el-radio>
        <el-radio label="after_opening">Gia sư sau khai giảng</el-radio>
        <el-radio label="buffer">Gia sư lớp đệm</el-radio>
        <el-radio label="retake">Gia sư thi lại</el-radio>
        <el-radio label="supplement">Gia sư bổ trợ</el-radio>
      </el-radio-group>
    </div>

    <SpecialTutor v-if="form.category === 'special'" @closeModal="closeModal" />
    <AfterOpeningTutoring v-if="form.category === 'after_opening'" @closeModal="closeModal" />
    <BufferClassTutoring v-if="form.category === 'buffer'" @closeModal="closeModal" />
    <RetakeTutor v-if="form.category === 'retake'" @closeModal="closeModal" />
    <SupplementTutor v-if="form.category === 'supplement'" @closeModal="closeModal" />
  </div>
</template>

<script>
import SpecialTutor from "@/view/pages/tutor/task-management/add-task-management/SpecialTutor.vue";
import AfterOpeningTutoring from "@/view/pages/tutor/task-management/add-task-management/AfterOpeningTutoring.vue";
import BufferClassTutoring from "@/view/pages/tutor/task-management/add-task-management/BufferClassTutoring.vue";
import RetakeTutor from './RetakeTutor.vue';
import SupplementTutor from './SupplementTutor.vue';

export default {
  name: 'AddTutorTask',
  components: {
    BufferClassTutoring,
    AfterOpeningTutoring,
    SpecialTutor,
    RetakeTutor,
    SupplementTutor
  },
  props: {
    visible: { type: Boolean, default: true }
  },
  data() {
    return {
      form: {
        category: 'special',
        studentId: '',
        content: '',
        budgetId: '',
        duration: '',
        date: '',
        time: ''
      }
    };
  },
  methods: {
    closeModal(isCreateSuccessful) {
      if (isCreateSuccessful) {
        this.$emit('closeModal', isCreateSuccessful);
        return;
      }

      this.$emit('comeBack');
    }
  }
};
</script>

<style scoped>
.tutor-booking-card {
  max-width: 900px;
  margin: 0 auto;
}
</style>
